import { useMutation } from 'react-query';

import { trackEvent } from '@/analytics/trackEvent';
import { SAVE_SUMMARY_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import { useInvalidateFetchSummarisationStatus } from '@/features/Summarisation/hooks';
import { CommonErrorToast, LoadingToast } from '@/utils/toasts';

export const useCreateSummary = () => {
  const invalidateSummarisationStatus = useInvalidateFetchSummarisationStatus();
  return useMutation(
    ({ deeplink }: MutationData) => {
      return axiosInstance.post(SAVE_SUMMARY_API_ROUTES.v2_index(), {
        deeplink,
      });
    },
    {
      onSuccess: async (_, { deeplink, source }) => {
        LoadingToast(
          'Your summary is currently being generated, and we will notify you once it is complete.'
        );
        await invalidateSummarisationStatus(deeplink);
        trackEvent('summary_request_successful', {
          source,
        });
      },
      onError: () => {
        CommonErrorToast();
      },
    }
  );
};

type MutationData = {
  deeplink: string;
  source: string;
};
